// A route change leaves focus on <body>, or on the control that navigated,
// and a screen reader hears nothing. Once the new page's <h1> renders, focus
// moves there, unless the page autofocuses a field or the member has already
// moved focus themselves.

const GIVE_UP_MS = 10_000;

let stop = () => {};
let latest = 0;

function focusHeading(left) {
  const at = document.activeElement;
  if (at && at !== document.body && at !== left) return true;
  if (document.querySelector("[autofocus]")) return true;

  const heading = document.querySelector("h1");
  if (!heading) return false;

  if (!heading.hasAttribute("tabindex")) heading.setAttribute("tabindex", "-1");
  heading.focus({ preventScroll: true });
  return true;
}

function afterRender(callback) {
  requestAnimationFrame(() => requestAnimationFrame(callback));
}

const PageFocusPort = {
  add: function (app) {
    app.ports.focusPage.subscribe(() => {
      stop();
      const call = ++latest;
      const left = document.activeElement;
      afterRender(() => {
        if (call !== latest || focusHeading(left)) return;

        const observer = new MutationObserver(() => {
          if (focusHeading(left)) stop();
        });
        const timeout = setTimeout(() => stop(), GIVE_UP_MS);
        observer.observe(document.body, { childList: true, subtree: true });
        stop = () => {
          observer.disconnect();
          clearTimeout(timeout);
          stop = () => {};
        };
      });
    });
  },
};

module.exports = PageFocusPort;
